import { CcRequirementReviewMethod } from "server/models"
import { OrderType, inferLiteral } from "client/utils"
import * as types from "./types"


export const setCcRequirementReviewMethodList = (methodList: types.CcRequirementReviewMethodList) => ({
    type: inferLiteral(types.CC_REQUIREMENT_REVIEW_METHOD_LIST),
    methodList,
})
export const setCcRequirementReviewMethodIds = (methodIds: readonly number[]) => ({
    type: inferLiteral(types.CC_REQUIREMENT_REVIEW_METHOD_IDS),
    methodIds,
})
export const setCcRequirementReviewMethodEdit = (method: CcRequirementReviewMethod) => ({
    type: inferLiteral(types.CC_REQUIREMENT_REVIEW_METHOD_EDIT),
    method,
})
export const setCcRequirementReviewMethodSort = (sortColumn: keyof CcRequirementReviewMethod, sortOrder: OrderType) => ({
    type: inferLiteral(types.CC_REQUIREMENT_REVIEW_METHOD_SORT),
    sortColumn,
    sortOrder,
})
export const setCcRequirementReviewMethodFilters = (filters: types.CcRequirementReviewMethodFilters) => ({
    type: inferLiteral(types.CC_REQUIREMENT_REVIEW_METHOD_FILTERS),
    filters,
})
export const setCcRequirementReviewMethodReloadList = (value: boolean) => ({
    type: inferLiteral(types.CC_REQUIREMENT_REVIEW_METHOD_RELOAD_LIST),
    value,
})
export const setCcRequirementReviewMethodReloadEdit = (value: boolean) => ({
    type: inferLiteral(types.CC_REQUIREMENT_REVIEW_METHOD_RELOAD_EDIT),
    value,
})
